jQuery.feature_import("js-holidayeditview",
  () => import("./holidayEdit.js"),
  mod => mod.feature_js_holidayeditview
);